import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { SubTabs } from 'shared/components';
import COD_PARCEL_ORDER_STATUS_QUERY, {
  CodParcelOrderStatusData,
} from 'shared/graphql/query/codParcelOrderStatus';
import { CodParcelOrderStatus } from 'views/CashOnDelivery/Routes/CashOnDeliveryByParcel/common/model/codParcelOrderStatus.model';

interface CodItemTabsProps {
  name: string;
  tab: CodParcelOrderStatus;
  onChange: (tab: CodParcelOrderStatus) => void;
}

const CodItemTabs: React.FC<CodItemTabsProps> = (props) => {
  const { tab, onChange, name } = props;
  const { data, refetch } = useQuery<CodParcelOrderStatusData>(COD_PARCEL_ORDER_STATUS_QUERY, {
    fetchPolicy: 'cache-and-network',
  });

  const checkSelectTab = (id: CodParcelOrderStatus) => {
    return id === tab && name === 'codItem';
  };

  const selectTab = (index: CodParcelOrderStatus) => {
    refetch();
    onChange(index);
  };

  const tabs = [
    {
      id: CodParcelOrderStatus.WAIT_TO_PAY,
      name: 'รอจ่าย COD',
      color: 'badge-grey',
      count: data?.codParcelOrderStatus.wait_to_pay || 0,
      divider: false,
    },
    {
      id: CodParcelOrderStatus.COD_OUT,
      name: 'สั่งจ่ายแล้ว',
      color: 'badge-grey',
      count: data?.codParcelOrderStatus.codOut || 0,
      divider: false,
    },
    {
      id: CodParcelOrderStatus.PAID,
      name: 'จ่ายเรียบร้อย',
      color: 'badge-grey',
      count: data?.codParcelOrderStatus.paid || 0,
      divider: false,
    },
  ].map((item) => ({
    id: item.id,
    name: item.name,
    count: item.count,
    active: checkSelectTab(item.id),
    clicked: () => selectTab(item.id),
    badgeClassName: checkSelectTab(item.id) ? item.color : null,
    divider: item.divider,
  }));

  return <SubTabs tabs={tabs} />;
};

export default CodItemTabs;
